import { ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "./ui/button.js";

/**
 * 403 view. Shown when a customer_admin reaches a portal-only route directly,
 * or when the API returns a scope error. The session is still valid — this is
 * not a login redirect.
 */
export function Forbidden({
  message = "You do not have access to this area."
}: {
  message?: string;
}): JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24 text-center">
      <div className="rounded-full bg-destructive/10 p-3">
        <ShieldAlert className="h-7 w-7 text-destructive" />
      </div>
      <div className="space-y-1">
        <h2 className="text-lg font-semibold tracking-tight">Access denied</h2>
        <p className="max-w-sm text-sm text-muted-foreground">{message}</p>
      </div>
      <Button asChild variant="outline">
        <Link to="/dashboard">Back to dashboard</Link>
      </Button>
    </div>
  );
}
